import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import styled from '@emotion/styled';

import { Box, ButtonLink, Text } from '@clutter/clean';

import { Spinner } from '@portal/components/helpers';
import { orderURL } from '@portal/config/routes';
import { useOrderDetailsQuery } from '@portal/schema';

import { Container } from './container';

const Title = styled(Text.Title)`
  margin-bottom: 24px;
`;

const Body = styled(Text.Body)`
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const COIInfo: React.FC<RouteComponentProps<{ orderID: string }>> = ({
  match: {
    params: { orderID },
  },
}) => {
  const { data: orderDetailsData, loading: orderDetailsLoading } = useOrderDetailsQuery({ variables: { orderID } });

  const isLoading = orderDetailsLoading || !orderDetailsData;

  if (isLoading) {
    return <Spinner />;
  }

  const { order } = orderDetailsData;
  return (
    <Container breadcrumb="COI" orderID={order.id} scheduled={order.scheduled}>
      <Box>
        <Title size="large">Download a COI</Title>
        <Body>
          Some properties require a Certificate of Insurance (COI) to be provided by moving companies before your moving
          day. Clutter is an Iron Mountain company and insured through Iron Mountain's insurance company, ACE American
          Insurance.
        </Body>

        <Body>Most properties will accept a copy of Clutter and Iron Mountain's publicly available COI.</Body>

        <ButtonLink
          size="medium"
          kind="primary"
          href="/public_documents/public_coi"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginBottom: '24px' }}
        >
          Download Public COI
        </ButtonLink>

        <Body>
          If your property requires a COI to be generated for your specific order, then please submit a custom COI
          request. Once you fill out the requested materials, we will email a completed Certificate of Insurance (COI)
          to you and your building manager.
        </Body>

        <ButtonLink size="medium" kind="primary" to={orderURL(orderID, 'request_a_coi')}>
          Request a Custom COI
        </ButtonLink>
      </Box>
    </Container>
  );
};
